<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">购物车商品修改</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">
                <el-form ref="editForm">
                    <div>
                        <el-row>
                            <el-col :span="24" class="item">
                                <el-col :span="10" class="item">
                                    <el-form-item label="商品数量" required>
                                        <el-input-number v-model="number" @change="handleChange" style="width:100%" :min="1" label="描述文字"></el-input-number>
                                    </el-form-item>
                                </el-col>
                            </el-col>
                            <el-col :span="24" class="item">
                                <el-col :span="18" class="item" v-if="goodsType>1">
                                    <el-form-item label="选择预约时间" required>
                                        <el-date-picker
                                            v-model="planTime"
                                            type="datetime"
                                            :clearable="false"
                                            placeholder="请选择预约时间"
                                            :default-value="new Date()"
                                            :picker-options="pickerOptions0"
                                            value-format="yyyy-MM-dd HH:mm:00"
                                            format="yyyy-MM-dd HH:mm:00"
                                            style="width:100%">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                            </el-col>
                        </el-row>
                    </div>

                </el-form>


            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm()">修改</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";


    export default {
        name: 'CartEdit',
        data() {
            return {
                loading: false,
                number:1,
                planTime:'',
                cartGoodsStaffCode:'',
                goodsType:'',
                elderlyCode:'',
                row:'',
                pickerOptions0: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                },  
                rules:{
                    name:[
                        { required: true, message: '请输入名称', trigger: 'blur' },
                    ],
                    sort:[
                        { required: true, message: '请输入排序', trigger: 'blur' },
                        { type: 'number', message: '排序必须为数字值'}
                    ],

                }

            }
        },

        methods: {

            init(row,elderlyCode,goodsType){
                this.row=row
                this.number=row.number
                this.planTime=row.planTime
                this.cartGoodsStaffCode=row.cartGoodsStaffCode
                this.elderlyCode=elderlyCode
                this.goodsType=goodsType
            },

            closeSelf() {
                this.$emit("closeCartEdit");
            },

            confirm(){
                if(this.number!=this.row.number){
                    this.$axios({
                        method: 'post',
                        url: this.$shopUrl+"AppCare/CartStaffNumberChange",
                        data: {
                            sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                            timeStr:timeStr,
                            staffCode:getStaffCode(),
                            cartGoodsStaffCode:this.cartGoodsStaffCode,
                            number:this.number,
                            elderlyCode:this.elderlyCode,
                        }
                    }).then(
                        (response) => {
                            this.loading = false;

                            if (response.data.error == 0) {
                                if(this.planTime==this.row.planTime){
                                    this.$emit("closeCartEdit");
                                    this.$emit("getGoods");
                                }
                            }else if(response.data.error == 1){
                                this.$message.error(response.data.message)
                            }
                        }
                    )
                }
                if(this.planTime!=this.row.planTime){
                    this.$axios({
                        method: 'post',
                        url: this.$shopUrl+"AppCare/CartStaffPlanTimeChange",
                        data: {
                            sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                            timeStr:timeStr,
                            staffCode:getStaffCode(),
                            cartGoodsStaffCode:this.cartGoodsStaffCode,
                            planTime:this.planTime,
                            elderlyCode:this.elderlyCode,
                        }
                    }).then(
                        (response) => {
                            this.loading = false;
                            if (response.data.error == 0) {
                                this.$emit("closeCartEdit");
                                this.$emit("getGoods");
                            }else if(response.data.error == 1){
                                this.$message.error(response.data.message)
                            }
                        }
                    )
                }
                if(this.planTime==this.row.planTime&&this.number==this.row.number){
                    this.$emit("closeCartEdit");
                }
            },
            handleChange:function (selVal) {
                this.num = selVal;
            }

        }
    }


</script>





<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:  0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 500px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                height: 100%;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
